import React from 'react';
import { OverlayProvider, SSRProvider } from 'react-aria';
import PropTypes from '../../../node_modules/prop-types/index.js';
import { ThemeProvider } from 'styled-components';
import NotificationProvider from '../QuickActionNotification/NotificationProvider.js';
import LANG from '../../lang/lang.js';
import LangProvider from '../../lang/langProvider.js';
import NavigationProvider from '../../navigation/NavigationProvider.js';
import { THEMES } from '../../theme/index.js';

var MuxProvider = function MuxProvider(_ref) {
  var children = _ref.children,
    themeProvider = _ref.themeProvider,
    langProvider = _ref.langProvider,
    navigationProvider = _ref.navigationProvider,
    notificationProvider = _ref.notificationProvider,
    overlayProvider = _ref.overlayProvider;
  return /*#__PURE__*/React.createElement(ThemeProvider, themeProvider, /*#__PURE__*/React.createElement(LangProvider, langProvider, /*#__PURE__*/React.createElement(NavigationProvider, navigationProvider, /*#__PURE__*/React.createElement(OverlayProvider, overlayProvider, /*#__PURE__*/React.createElement(SSRProvider, null, /*#__PURE__*/React.createElement(NotificationProvider, notificationProvider, children))))));
};
process.env.NODE_ENV !== "production" ? MuxProvider.propTypes = {
  children: PropTypes.node.isRequired,
  /**
   * See [styled-components' `ThemeProvider`](https://styled-components.com/docs/advanced)
   */
  themeProvider: PropTypes.shape({
    theme: PropTypes.oneOf([THEMES.canadianTheme, THEMES.johnhancockTheme, THEMES.globalTheme])
  }),
  /**
   * See [LangProvider](/docs/lang-provider)
   */
  langProvider: PropTypes.shape({
    lang: PropTypes.oneOf([LANG.EN_CA, LANG.FR_CA])
  }),
  /**
   * See [NavigationProvider](/docs/navigation-provider)
   */
  navigationProvider: PropTypes.shape({
    isSignedIn: PropTypes.bool
  }),
  /**
   * See [react-aria's `useDialog`](https://react-spectrum.adobe.com/react-aria/useDialog.html)
   */
  overlayProvider: PropTypes.object,
  /**
   * See [Toast](/docs/toast)
   */
  notificationProvider: PropTypes.shape({
    interval: PropTypes.number
  })
} : void 0;
MuxProvider.defaultProps = {
  themeProvider: {
    theme: THEMES.canadianTheme
  },
  langProvider: {
    lang: LANG.EN_CA
  },
  navigationProvider: {
    isSignedIn: false
  },
  overlayProvider: {},
  notificationProvider: {
    interval: 4000
  }
};
process.env.NODE_ENV !== "production" ? MuxProvider.displayName = 'MuxProvider' : void 0;
var MuxProvider$1 = MuxProvider;

export { MuxProvider$1 as default };
